import React from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import { TransactionProvider } from './store';
import { TransactionPage } from './features/transaction';
import { NotFoundPage } from './features/notfound';
import { ErrorBoundary } from './shared/ui';

function App() {
  return (
    <ErrorBoundary>
      <TransactionProvider>
        <Router>
          <Routes>
            <Route path="/" element={<TransactionPage />} />
            <Route path="/not-found" element={<NotFoundPage />} />
            <Route path="/pagenotfound" element={<Navigate to="/not-found" replace />} />
            <Route path="*" element={<Navigate to="/not-found" replace />} />
          </Routes>
        </Router>
      </TransactionProvider>
    </ErrorBoundary>
  );
}

export default App;
